import { AccordionSummary } from "@mui/material";
import { Box } from "@mui/system";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Typography } from "@mui/material";
import { HeadingLevel } from "@/core/types/types";

const AccordionSummaryText = ({ text }: { text: string }) => (
  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
    <InfoOutlinedIcon fontSize="medium" />
    <Box display="flex" alignSelf="center" ml={1}>
      <Typography variant={HeadingLevel.Body2}>{text}</Typography>
    </Box>
  </AccordionSummary>
);

export default AccordionSummaryText;
